angular.
module("digiexam.components").
directive("autofocusIf", function autofocusIfDirective() {
	"use strict";

	return {
		restrict: "A",

		link: function link(scope, el, attr) {
			if (scope.$eval(attr.autofocusIf)) {
				el[0].focus();
			}
		},
	};
});
